/**
 Search filter
 */

import React, {useState, useEffect, useRef} from 'react';
import {t} from "../../translation";

const SearchFilter = ({notifyOnChange, value, placeholder='Search', autoFocus=true, actionTimeout=1600, width=null, maxWidth=null, maxInputWidth=null, height=null, domID='search-filter'}) => {
    const [searchQuery, setSearchQuery] = useState(value);
    const searchFilterTimeout = useRef(null);
    const containerStyle = {
        maxWidth: maxWidth ?? '300px'
    };
    if(width !== null)
    {
        containerStyle.width = width;
    }
    const inputStyle = {
        maxWidth: maxInputWidth ?? '380px',
        paddingRight: '30px'
    };
    if(height !== null)
    {
        inputStyle.height = height;
        inputStyle.minHeight = height;
    }

    /**
     * Clears search on escape
     */
    useEffect(() => {
        const inputID = `#${domID}`;
        window.jQuery(inputID).on('keydown.search', (e) => {
            if(e.which === 27) //Escape
            {
                if(searchQuery === '')
                {
                    return;
                }
                setSearchQuery('');
                notifyOnChange('');
            }
        });
        return () => {
            window.jQuery(inputID).off('keydown.search');
        };
    }, [notifyOnChange, searchQuery, domID]);

    /**
     * On search change
     */
    const onSearchInputChange = ({target}) => {
        setSearchQuery(target.value);
        if(searchFilterTimeout.current)
        {
            clearTimeout(searchFilterTimeout.current);
            searchFilterTimeout.current = null;
        }
        searchFilterTimeout.current = setTimeout(() => {
            notifyOnChange(target.value);
        }, actionTimeout);
    };
    return (
        <div className="position-relative search-bar-box ms-2" style={containerStyle}>
            <input type="text" id={domID} className="form-control search-control" placeholder={t(placeholder)} autoFocus={autoFocus}
                   onChange={onSearchInputChange} value={searchQuery} style={inputStyle}/>
            <span className="position-absolute top-50 search-show translate-middle-y">
                <i className="bx bx-search"/>
            </span>
            <span className="position-absolute top-50 search-close translate-middle-y">
                <i className="bx bx-x"/>
            </span>
        </div>
    );
};

export default React.memo(SearchFilter);
